/**
 * 注册占位 Service Worker（Issue #198）。
 *
 * 第一版只为客户端建立 PWA 入口（manifest + 可安装），不做离线缓存、
 * 不做后台同步、不做推送。任何敏感数据（健康资料、订单、签名 URL）都
 * 必须实时向后端请求，不得由 SW 缓存。这里只在生产构建注册，避免开发
 * 期 HMR 与 SW 冲突。
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(() => {
        // SW registration failures must not break the app. The portal works as
        // a normal HTML site without an installed SW; we only lose the
        // "add to home screen" cue.
      });
  });
}
